import { UNSCHEDULED_BOOKING_STATES } from 'Data/constants.js'
import { currentTzDate, formatTzDate } from 'Data/format.js'

export function getView(event) {
  let booking = event.appointment.booking?.[0]
  if (!booking) return 'Schedule'
  if (UNSCHEDULED_BOOKING_STATES.includes(booking.state)) return 'Reschedule'

  let timeZoneId = booking.chair.resource.organization.time_zone_id
  let isToday =
    formatTzDate(currentTzDate(timeZoneId), 'yyyy-MM-dd', timeZoneId) ===
    booking.local_start_date

  if (!isToday) return 'No'

  switch (booking.state) {
    case 'SCHEDULED':
      return 'CheckIn'
    case 'CHECKED_IN':
      return 'Seat'
    case 'SEATED':
      return 'Unseat'
    case 'UNSEATED':
      return 'Checkout'
    default:
      return 'No'
  }
}
